module.exports = __webpack_public_path__ + "img/ms_get.0b0fb1d.png";